import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import RootLayout from "./app/layout"; // Import the new RootLayout

// Providers are now handled within RootLayout

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

// Render App inside RootLayout. Providers are handled by RootLayout.
root.render(
	<StrictMode>
		{/* RootLayout now wraps the App and provides context */}
		<RootLayout>
			<App />
		</RootLayout>
	</StrictMode>,
);
